import Repository from "./Repository";

const SAVE_BOOK_MARKS = "add";
const GET_BOOK_MARKS = "get";
const DELETE_BOOK_MARKS = "delete";

export default {
  SaveBookmark(payload) {
    return Repository.post(transformRoute(SAVE_BOOK_MARKS), payload);
  },
  GetBookmarks(payload) {
    return Repository.post(transformRoute(GET_BOOK_MARKS), payload);
  },
  DeleteBookmark(payload) {
    return Repository.post(transformRoute(DELETE_BOOK_MARKS), payload);
  },
};
const transformRoute = (route) => {
  return `bookmarks/${route}`;
};
